import Seo from "../components/Seo";
import { PageHero } from "../components/common/Section";
import TiltServiceCard from "../components/home/TiltServiceCard";
import { useSettings } from "../context/SettingsContext";

export default function Services() {
  const { services } = useSettings();
  return (
    <>
      <Seo title="Our Financial Services" path="/services" />
      <PageHero eyebrow="Our Financial Services" title="Every part of your financial life, planned together." text="Insurance, mutual funds, investments, wealth & tax planning and financial education, delivered with transparency about what each service is and is not." />
      <section className="bg-slate-100/70 py-24">
        <div className="container-q grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="services-list">
          {services.map((s, i) => <TiltServiceCard key={s.slug} service={s} index={i} />)}
        </div>
      </section>
    </>
  );
}
